import React, { ChangeEvent, Fragment, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { RouteComponentProps } from 'react-router'
import { Box, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, Divider, Grid, makeStyles, TextField } from '@material-ui/core'
import { FixMeLater } from 'types/FixMeLaterType'
import FileSaver from 'file-saver'
import DropdownSelect from 'components/dropdown-select/DropdownSelect'
import Textbox from 'components/textbox/Textbox'
import { getIcon } from 'icon/icon'
import FileDrop from 'components/file-drop/FileDrop'
import { Loading } from 'components/loading/Loading'



interface LayoutCardProps {
    title?: string,
    subheader?: string,
    layout: LayoutComponentProps[]
    right?: JSX.Element | string | null,
    cardHeight?: string | number
}

interface LayoutComponentProps {
    type: typeof TextField | typeof DropdownSelect | typeof CardMedia | typeof Textbox |
    typeof FileDrop,
    data?: FixMeLater[],
    handleChange: ((data: FixMeLater) => void)
    value: FixMeLater,
    label: string,
    disabled?: boolean
    alt?: string,
    src?: string,
    height?: string | number
    onClick?: ((event: FixMeLater) => void),
    grid?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
    multiple?: boolean,
    message?: string
}

const useStyles = makeStyles({
    root: {
        objectFit: "contain",
        margin: "8px"
    },
    headerAction: {
        margin: "-8px",
        alignSelf: "center"
    },
    card: {
        height: (props: LayoutCardProps) => props.cardHeight
    }
})

interface CustomTextFieldProps {
    value: string,
    label: string,
    handleChange: (data: FixMeLater) => void,
    disabled?: boolean | null
}

function CustomTextField(props: CustomTextFieldProps) {

    function handleChange(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
        props.handleChange(event.target.value)
    }

    return (
        <TextField
            InputLabelProps={{ shrink: !!props.value }}
            value={props.value}
            label={props.label}
            onChange={handleChange}
            margin="dense"
            variant="outlined"
            fullWidth
            multiline
            disabled={!!props.disabled}
        />
    )
}

function LayoutCard(props: LayoutCardProps) {

    const classes = useStyles(props)

    const [imageLoading, setImageLoading] = useState(true)

    const imageLoaded = () => setImageLoading(false);


    function componentSelector(componentProps: LayoutComponentProps): JSX.Element {
        switch (componentProps.type) {
            case TextField:
                return <CustomTextField {...componentProps} />
            case DropdownSelect:
                return <DropdownSelect data={componentProps.data || []} {...componentProps} />
            case CardMedia:
                return <Fragment>
                    <Box style={{ display: imageLoading ? "block" : "none" }} >
                        <Loading />
                    </Box>
                    <CardMedia
                        src={componentProps.value}
                        component="img"
                        style={{ display: imageLoading ? "none" : "block" }}
                        className={classes.root}
                        onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                            console.log(e)
                            const emptyImage = getIcon("empty-file.svg")
                            e.currentTarget.src = emptyImage.props.src
                        }}
                        onLoad={imageLoaded}
                        alt={componentProps.alt} height={componentProps.height}
                    />
                </Fragment>
            case Textbox:
                return <Textbox data={componentProps.data || []} {...componentProps} />

            case FileDrop:
                return <FileDrop file={componentProps.value} onFilesAdded={componentProps.handleChange} {...componentProps} />
            default:
                return <Box />
        }
    }

    return (
        <Box>
            <Card className={classes.card}>
                {
                    !!props.title || !!props.subheader || !!props.right ?
                        <Fragment>
                            <CardHeader
                                classes={{ action: classes.headerAction }}
                                title={props.title}
                                subheader={props.subheader}
                                action={props.right}
                            />
                            <Divider />
                        </Fragment>
                        : null
                }
                <CardContent>
                    <Grid container spacing={2}>
                        {
                            props.layout.map((layoutItem: LayoutComponentProps) => (
                                <Grid key={layoutItem.label} item xs={layoutItem.grid}>
                                    { componentSelector(layoutItem)}
                                </Grid>
                            ))
                        }
                    </Grid>
                </CardContent>
                <CardActions>

                </CardActions>
            </Card>
        </Box >
    )
}

LayoutCard.propTypes = {

}

export default LayoutCard

